import { Skeleton, Typography } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { toIndianRupeeFormat } from '../custom';

const OrderForm = ({
  buttonType,
  activeTab,
  setActiveTab,
  inputPrice,
  setInputPrice,
  qtyValue,
  handleQtyChange,
  handleQtyIncrement,
  handleQtyDecrement,
  lotsValue,
  handleLotsChange,
  handleLotsIncrement,
  handleLotsDecrement,
  availableMargin,
  isLoading,
  onSwipeComplete
}) => {
  const handlePriceChange = (e) => {
    const value = e.target.value;
    if (/^\d*\.?\d*$/.test(value)) {
      setInputPrice(value);
    }
  };
  const { clientPositions, loading, hasLoadedOnce } = useSelector((state) => state.portfolio);

  const {
    ledger_balance = 0,
    available_margin = 0,
    used_margin = 0,
    m2m = 0,
    active_pnl = 0,
    closed_pnl = 0,
    total_pnl = 0,
  } = clientPositions || {};

  const renderValue = (value, color) => {
    if (showShimmer) {
      return <Skeleton variant="text" width={60} height={20} />;
    }
    return (
      <Typography variant="body2" style={{ color }} className="font-lato text-[13px]">
        {value}
      </Typography>
    );
  };

  const showShimmer = loading && !hasLoadedOnce;

  const isPositive = (val) => val >= 0;
  const pnlColor = (val) => isPositive(val) ? '#16a34a' : '#dc2626';
  const pnlPrefix = (val) => isPositive(val) ? '+ ₹' : '- ₹';
  const absFormat = (val) => toIndianRupeeFormat(Math.abs(val));

  const isBuy = buttonType === "buy";
  const primaryColor = isBuy ? "#089981" : "#f23645";
  const primaryColorLight = isBuy ? "#0899811a" : "#f236451a";

  const renderTabButton = (tabName, label, width = "100px") => (
    <a
      role="tab"
      onClick={() => setActiveTab(tabName)}
      className={`${activeTab === tabName
        ? `bg-[${primaryColor}] text-white`
        : "bg-transparent text-black"
        } font-lato text-[14px] rounded-[10px] text-center h-[36px] py-[8px] px-[14px] cursor-pointer`}
      style={{
        width: width,
        backgroundColor: activeTab === tabName ? primaryColor : 'transparent'
      }}
    >
      {label}
    </a>
  );

  const renderQuantityControl = (label, value, onIncrement, onDecrement, onChange, readOnly = false) => (
    <div className="flex flex-col items-left w-1/2">
      <label className="text-[14px] mb-[8px] leading-[21px] text-[#1a1a1a] font-lato">
        {label}
      </label>
      <div className="flex items-center justify-between w-full mt-1 rounded-md py-1">
        <button
          className="w-[36px] h-[36px] leading-[30px] rounded-[4px] text-[24px]"
          style={{
            backgroundColor: primaryColorLight,
            color: primaryColor
          }}
          onClick={onDecrement}
        >
          -
        </button>
        <input
          type={readOnly ? "text" : "number"}
          step="any"
          placeholder={label?.toLowerCase()}
          value={readOnly ? (value ?? 0).toFixed(2) : value}
          onChange={onChange}
          readOnly={readOnly}
          className="w-[80px] h-[36px] border text-center bg-white font-semibold px-[6px] leading-[21px] text-[14px] text-[#6e6b7b] rounded-[4px]"
        />
        <button
          className="w-[36px] h-[36px] leading-[30px] rounded-[4px] text-[24px]"
          style={{
            backgroundColor: primaryColorLight,
            color: primaryColor
          }}
          onClick={onIncrement}
        >
          +
        </button>
      </div>
    </div>
  );

  return (
    <div className="bg-white p-3">

      <>
        <div className="flex items-center flex-row-reverse mt-1">
          <div className="flex rounded-[10px]" style={{ backgroundColor: primaryColorLight }}>
            {renderTabButton("limit", "LIMIT")}
            {renderTabButton("market", "MARKET")}
            {renderTabButton("stoploss", "STOPLOSS")}
          </div>
        </div>

        <label className="text-[14px] leading-[21px] text-[#1a1a1a] font-lato">
          Price
        </label>
        <div className="flex items-center justify-between mt-1">
          <input
            value={inputPrice}
            type="text"
            readOnly={activeTab === "market"}
            onChange={handlePriceChange}
            className="w-[150px] h-[36px] bg-white border rounded-[5px] text-[1rem] px-[0.75rem] py-[0.375rem]"
          />
        </div>
      </>


      {/* Qty & Lots Section */}
      <div className="flex justify-between gap-2 mt-8">
        {renderQuantityControl(
          "Lots",
          lotsValue,
          handleLotsIncrement,
          handleLotsDecrement,
          handleLotsChange,
          false
        )}
        {renderQuantityControl(
          "Qty",
          qtyValue,
          handleQtyIncrement,
          handleQtyDecrement,
          handleQtyChange
        )}
      </div>

      <div className="flex flex-col items-center m-[2rem] p-[0rem] bg-gray-100">
        <label className="text-[1rem] text-center p-[1rem] leading-[21px] text-[#1a1a1a] font-lato">
          {/* Available Margin : {toIndianRupeeFormat(availableMargin)} */}
          Available Margin :  {showShimmer
            ? <Skeleton variant="text" width={60} height={20} />
            : (
              <Typography style={{ color: pnlColor(available_margin) }} className="text-[13px]">
                {pnlPrefix(available_margin)}{absFormat(available_margin)}
              </Typography>
            )}
        </label>
      </div>
    </div>
  );
};

export default OrderForm;